import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../Services/api.service';
import { StorageService } from '../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../Services/sweetalet.service';

import { Subject } from 'rxjs';
declare const Swal;

@Component({
    selector: 'view-request',
    templateUrl: './view-request.component.html',
    styleUrls: ['./view-request.component.css']
})

export class ViewRequestComponent implements OnInit {
    searchKey = 'title'
    constructor(
        private storage: StorageService,
        private api: ApiService,
        private router: Router,
        private swal: SweetAlert
    ) {

    }
    requestData: any;
    reqApiData = {};
    public allRequestData = [];
    searchedValue = '';
    statusValue: any;
    public searchInput: any = new Subject<string>();
    custRequestData: any;
    reqList: any = ['on_board_request', 'location_request', 'route_change', 'time_change', 'shift_change', 'leave_request','address_update','route_request','route_cancel','adhoc_request'];
    requestValue = [
        { value: 'custom_request', viewValue: 'Custom Request' },
        { value: 'location_request', viewValue: 'Location Request' },
        { value: 'leave_request', viewValue: 'Leave Request' },
        { value: 'on_board_request', viewValue: 'On board Request' },
        { value: 'route_change', viewValue: 'Route Change' },
        { value: 'shift_change', viewValue: 'Shift Change' },
        { value: 'time_change', viewValue: 'Time Change' },
        { value: 'address_update', viewValue: 'Address Update' },
        { value: 'route_request', viewValue: 'Route Request' },
        { value: 'route_cancel', viewValue: 'Route Cancel' },  
        { value: 'adhoc_request', viewValue: 'Adhoc Request' },
    ];
    requestCheckboxValue = [
        { name: 'custom_request', value:false, viewValue: 'Custom Request' },
        { name: 'location_request', value:false, viewValue: 'Location Request' },
        { name: 'leave_request', value:false, viewValue: 'Leave Request' },
        { name: 'on_board_request', value:false, viewValue: 'On board Request' },
        { name: 'route_change', value:false, viewValue: 'Route Change' },
        { name: 'shift_change', value:false, viewValue: 'Shift Change' },
        { name: 'time_change', value:false, viewValue: 'Time Change' },
        { name: 'address_update', value:false, viewValue: 'Address Update' },
        { name: 'route_request', value:false, viewValue: 'Route Request' },
        { name: 'route_cancel', value:false, viewValue: 'Route Cancel' },
        { value: 'adhoc_request', viewValue: 'Adhoc Request' },
    ];

    toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

    countMenuObj:any = {
        'high':0,
        'low':0,
        'medium':0,
        'newRequest':0,
        'overdue':0,
        'processed':0,
        'unprocessed':0,
    };

    isShowCusReq = false;
    isShowRequst = false;
    public dataForOption;

    public objKeys = Object.keys;

    ngOnInit() {
        this.getListRequest();
        setTimeout(()=>{
            this.getCustListRequest();
        },500)
    }

    public toggleMenu:boolean = false;
    public searchList = [];
    public searchOptionChanges:boolean = false;
    toggleDropdown(){
        this.toggleMenu = !this.toggleMenu;
        if (!this.toggleMenu && this.searchOptionChanges){
            this.searchOptionChanges = false;
            this.loadFinalData(); // If dropdown closing then load data
        }
    }
    searchOption(val,index){
        this.searchOptionChanges = true;
        this.requestCheckboxValue[index]['value']=val;
    }
    loadFinalData(){
        this.searchList = [];
        this.requestCheckboxValue.filter((e)=>{ if (e.value==true) this.searchList.push(e.name) });
        if (this.searchList.length <= 0) { 
            document.getElementById('searchInputField').setAttribute("disabled",'true');
        }
        if (this.searchList.length > 0) { 
            document.getElementById('searchInputField').removeAttribute("disabled");
            // this.requstTypeValue(this.searchList);
        }
        this.requstTypeValue(this.searchList);
    }


    getListRequest(val?) {
        let obj = {};
        if (val) {
            obj['requestType'] = val
        }
        this.api.ListRequest(obj).then((res: any) => {
            this.isShowRequst = true;
            let dataKeys = Object.keys(res.data);
            dataKeys.filter((e)=>{ 
                this.requestCheckboxValue.filter((reqVal)=>{ if(e == reqVal['name']) reqVal.value=true; })
            });
            this.reqApiData = res.data;
            this.requestData = {
                'custom_request': res.data['custom_request'] ? res.data['custom_request'] : [], 
                'location_request': res.data['location_request'] ? res.data['location_request'] : [], 
                'leave_request': res.data['leave_request'] ? res.data['leave_request'] : [], 
                'on_board_request': res.data['on_board_request'] ? res.data['on_board_request'] : [], 
                'route_change': res.data['route_change'] ? res.data['route_change'] : [], 
                'shift_change': res.data['shift_change'] ? res.data['shift_change'] : [], 
                'time_change': res.data['time_change'] ? res.data['time_change'] : [], 
                'address_update': res.data['address_update'] ? res.data['address_update'] : [],
                'route_request': res.data['route_request'] ? res.data['route_request'] : [],
                'route_cancel': res.data['route_cancel'] ? res.data['route_cancel'] : [], 
                'adhoc_request': res.data['adhoc_request'] ? res.data['adhoc_request'] : [],
                'route_location_change_request': res.data['route_location_change_request'] ? res.data['route_location_change_request'] : [],

            }
            // this.getMenuCount();

        }).catch((err) => {
            console.log(err);
        });
    }

    getCustListRequest() {
        const obj = {
            orgID: this.storage.get('userInfo').orgID,
        };
        // this.api.ListRequest(obj).then((res: any) => {
        this.api.ListCustomRequest(obj).then((res: any) => {
            //this.custRequestData = res.data;
            this.isShowCusReq = true;
            // res.data.filter((e)=>{
            //     this.requestCheckboxValue.filter((obj)=>{ if(e['requestType'] == obj['name']) obj.value=true; })
            //     this.allRequestData.unshift(e);
            // });
            // this.requestData = this.allRequestData;
            // this.getMenuCount();

        }).catch((err) => {
            console.log(err);
        });
    }

    checkNoDataFound(data){
        let result:boolean = false;
        if(data){
            let reqKeys = this.objKeys(data);
            if(reqKeys.length<=0){
                result = true;
            }else{
                if(reqKeys.length>0){
                    let check = true;
                    reqKeys.filter((key)=>{
                        if(data[key].length>0){
                            check = false;
                        }
                    })
                    result = check;
                }
                else result = false;
            }
        }
        else result = true;
        return result;
    }

    action(data, type) {
        const obj = {
            orgID: this.storage.get('userInfo').orgID,
            requestID: data.requestID,
            status: type == 'accept' ? 'active' : 'inactive'
        };
        // if(type == 'waiting'){obj['status'] = 'waiting'}
        this.api.UpdateRequest(obj).then((res: any) => {
            this.getListRequest();
        });

    }
    requestAction(data, requestType) {
        if (requestType == 'custom_request') {
            this.router.navigate(['/organization/transport-manager/request/single-custom-request-view',data.requestID]);
        } else {
            this.router.navigate(['/organization/transport-manager/request/single-view-request',data.requestID ]);
        }
    }
    requestListAction(data,requestType){
        let type = requestType.split('_').join('-'); 
        this.router.navigate(['/organization/transport-manager/request/list-request',type]);
    }
    deleteRequestData(reqID) {
        const obj = {
            orgID: this.storage.get('userInfo').orgID,
            requestID: reqID
        };
        this.api.DeleteRequest(obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status, res.status, res.message, 2000);
                this.getListRequest();
            }
            if (res.status == 'failure') {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    upDateStatus(data, name?) {
        if (name == 'custom-report') {
            if (data.status == '0') { data.status = '1'; } else if (data.status == '1') { data.status = '0'; }
            const obj = {
                orgID: this.storage.get('userInfo').orgID,
                ...data
            };
            this.api.UpdateCustomRequest(obj).then((res: any) => {
                this.getCustListRequest();
            }).catch((err) => {
                console.log(err);
            });
        } else {
            if (data.status == '0') { data.status = '1'; } else if (data.status == '1') { data.status = '0'; }
            const obj = {
                orgID: this.storage.get('userInfo').orgID,
                ...data
            };
            this.api.UpdateRequest(obj).then((res: any) => {
                if (res.status == 'success') {
                    this.swal.swalFunction(res.status, res.status, res.message, 2000);
                    this.getListRequest();
                    this.getCustListRequest();
                }
                if (res == 'failure') {
                    this.swal.swalFunction('error', res.status, res.message, 2000);
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }
    requstTypeValue(e) {
        let requestArray = [];
        e.filter((requestType)=>{ 
                this.allRequestData.filter((element)=>{
                    if(element.requestType == requestType) requestArray.push(element); 
                })
            })
            this.requestData = requestArray;
      /*   if (e.length > 0) {
        } */
    }
    /* 
    requstTypeValue(e) {
        console.log(e);
        console.log(e.length, e.length > 0, e);
        this.isShowCusReq = false;
        this.isShowRequst = false;

        if (e.length > 0) {
            if (e.length == 1 && e.includes('custom_request')) {
                this.getCustListRequest();
                return;
            } else if (!e.includes('custom_request')) {
                let fnVal = e.toString()
                this.getListRequest(fnVal);
            } else {
                let arr = e.includes('custom_request')
                if (arr) {
                    let rmv = e.indexOf('custom_request')
                    this.getCustListRequest();
                    e.splice(rmv, 1)
                    console.log(rmv, e)
                    let fnVal = e.toString()
                    this.getListRequest(fnVal);
                }
                if (e.includes('custom_request')) { this.getCustListRequest(); }
            }
        } else {
            this.getListRequest();
            this.getCustListRequest();
        }

    } */
    getMenuCount(){
        for (const key of Object.keys(this.countMenuObj)) {
            this.countMenuObj[key] = 0;
        };

        if(this.requestData){
            this.requestData.filter((e)=>{
                switch(e['priority']){
                    case 'high': this.countMenuObj.high++; break;
                    case 'low': this.countMenuObj.low++; break;
                    case 'medium': this.countMenuObj.medium++; break;
                };
            }); 
            this.countMenuObj.newRequest = this.requestData.length;
            this.countMenuObj.unprocessed = this.requestData.length;
        }
    }
}
